export default __webpack_public_path__ + "2810fcb97838a1a03da0827024fe5cdc.png";